import React, { useContext } from "react";
import FormContextProvider from "../../context/FormContextProvider";
import SearchForm from "./SearchForm";
import { SearchContext } from "../../context/SearchContextProvider";

interface Props {

}

const SearchField : React.FC<Props> = () => {
    const {addSearchTerms} = useContext(SearchContext);
    return <>
        <FormContextProvider name="searchForm" onSubmit={(data) => addSearchTerms((data?.search?.split(" ") as string[]).filter(t => t?.length > 0))}>
            <SearchForm />
        </FormContextProvider>
    </>
}

export default SearchField;